import React, { useMemo } from 'react';
import { Dialog, DialogProps } from '@economic/taco';

import GenericSubscriptionChangeSuccessContent from '~/app/pages/settings/company/subscription/SubscriptionChangeSuccessComponents/GenericSubscriptionChangeSuccessContent';
import SmartPlanSubscriptionChangeSuccessContent from '~/app/pages/settings/company/subscription/SubscriptionChangeSuccessComponents/SmartPlanSubscriptionChangeSuccessContent';

interface Props {
    readMoreLink?: string | undefined;
    modalProps: Partial<DialogProps>;
    redirectToSubscriptionStatusPage?: boolean;
    planId: number;
    isDowngrade?: boolean;
}

export default function SubscriptionChangeSuccessDialog({
    planId,
    modalProps,
    readMoreLink,
    redirectToSubscriptionStatusPage,
    isDowngrade,
}: Props) {
    const content = useMemo(() => {
        // Smart plan and its XtoY variants
        if (!isDowngrade && [121, 122, 123, 124, 125].includes(planId)) {
            return (
                <SmartPlanSubscriptionChangeSuccessContent
                    readMoreLink={readMoreLink}
                    redirectOnClose={redirectToSubscriptionStatusPage ? '/settings/subscription/status' : undefined}
                />
            );
        }

        return (
            <GenericSubscriptionChangeSuccessContent
                readMoreLink={readMoreLink}
                redirectOnClose={redirectToSubscriptionStatusPage ? '/settings/subscription/status' : undefined}
            />
        );
    }, [isDowngrade, planId, readMoreLink, redirectToSubscriptionStatusPage]);

    return (
        <Dialog {...modalProps} showCloseButton={false} size="xs" defaultOpen>
            {content}
        </Dialog>
    );
}
